import moment from 'moment'

/**
 * Validator checks if a provided date is before now.
 *
 * @param {String|Number|Date|moment.Moment} date - date or moment object
 * @returns {boolean} - If no expected param type is provided or the provided date is in the future, it returns false.
 */
export function isDateBeforeNow(date) {
    if (date) {
        const castedDate = moment.isMoment(date) ? date : moment(date)
        if (castedDate.isValid()) {
            return castedDate.isBefore(moment())
        }
    }

    return false
}
